import remoteLoad from '../common';
/**
 * IOS环境下通过xInstall记录下载渠道
 */
class Install {
  constructor(key, options = {}) {
    this.key = key;
    this.options = options;
  }

  getXInstallAndWakeUp(options = {}) {
    return new Promise((resolve) => {
      (async () => {
        await remoteLoad('https://cdn.xinstall.com/xinstall.js');
        // 提供的工具函数，解析url中的所有查询参数
        // eslint-disable-next-line no-undef
        const data = XInstall.parseUrlParams();
        // eslint-disable-next-line no-undef
        const xinstall = new XInstall({
          appKey: this.key,
          ...options,
          onready() {
            xinstall.wakeupOrInstall();
          },
        }, data);
        resolve(xinstall);
      })();
    });
  }

  getXInstall(options = {}) {
    return new Promise((reslove) => {
      (async () => {
        await remoteLoad('https://cdn.xinstall.com/xinstall.js');
        // 提供的工具函数，解析url中的所有查询参数
        // eslint-disable-next-line no-undef
        const data = XInstall.parseUrlParams();
        // eslint-disable-next-line no-undef
        const xinstall = new XInstall({
          appKey: this.key,
          ...options,
        }, data);
        reslove(xinstall);
      })();
    });
  }
}

export default Install;
